import { useState as u, useCallback as a } from "../external/preact/hooks/dist/hooks.module.js";
const r = (s = !1) => {
  const [o, e] = u(s), l = a((t) => e(t), []), n = a(() => e((t) => !t), []);
  return [o, l, n];
};
export {
  r as default
};
